import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./style.css";
import {
  getBatchSessions,
  getCourseBatches,
} from "../../../../utils/services/batches/batchService";
import { useLocation } from "react-router-dom";
import { SessionAPI } from "../../../../utils/services/session-management";

const CloneResources = ({
  fetchResources,
  openCopyResources,
  setOpenCopyResources,
}) => {
  const handleClose = () => {
    setOpenCopyResources(false);
  };

  const { state } = useLocation();

  const [batch, setBatch] = useState(null);
  const [courseBatches, setCourseBatches] = useState([]);
  const [session, setSession] = useState(null);
  const [batchSessions, setBatchSessions] = useState(null);
  console.log(state);

  const handleSelectBatch = (e) => {
    setBatch(e?.target?.value);
    setSession(null);
  };

  const handleSelectSession = (e) => {
    setSession(e?.target?.value);
  };

  const handleReset = () => {
    setSession(null);
    setBatch(null);
  };

  const handleSubmit = async () => {
    const reqBody = {
      oldSessionId: session,
      newSessionId: state?.data?.id,
    };

    const { error } = await SessionAPI.cloneResources(reqBody);
    if (!error) {
      handleClose();
      fetchResources();
    }
  };

  useEffect(() => {
    const fetchCourseBatches = async () => {
      const params = {
        courseId: state?.courseId,
        batchId: state?.batchId,
      };
      const { payload, error } = await getCourseBatches(params);
      if (payload) {
        setCourseBatches(payload);
      }
    };

    fetchCourseBatches();
  }, []);

  useEffect(() => {
    const fetchBatchSessions = async () => {
      const { payload, error } = await getBatchSessions(batch);
      if (payload) {
        setBatchSessions(payload);
      }
    };

    if (batch) fetchBatchSessions();
  }, [batch]);

  return (
    <>
      <Dialog open={openCopyResources} fullWidth="md" onClose={handleClose}>
        <DialogTitle>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p>Clone Resources</p>
            <div className="close-clone-modal" onClick={handleClose}>
              <Close />
            </div>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div>
            {/* <p>Choose batch to select common resources from</p> */}
            <div className="select-batch">
              <FormControl fullWidth>
                <InputLabel>Batch</InputLabel>
                <Select
                  label="Batch"
                  onChange={handleSelectBatch}
                  value={batch}
                >
                  {courseBatches?.map((batch) => (
                    <MenuItem key={batch?.id} value={batch?.id}>
                      {batch?.batchId}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div>
            {/* <p>Choose Session to select common resources from</p> */}
            <div className="select-session">
              <FormControl fullWidth>
                <InputLabel>Session</InputLabel>
                <Select
                  label="Session"
                  onChange={handleSelectSession}
                  value={session}
                >
                  {batchSessions?.map((session) => (
                    <MenuItem key={session?.id} value={session?.id}>
                      {session?.sessionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReset}>Reset</Button>
          <Button
            variant="contained"
            disabled={!(session && batch)}
            onClick={handleSubmit}
          >
            Clone
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CloneResources;
